import type { Product } from '../data/products'
import { ArrowUpRight } from 'lucide-react'
import { getLocale, localizeNode } from '../i18n/locales'
export function StoreLinks({ product, compact = false }: { product: Product; compact?: boolean }) {
  const locale = getLocale()
  return localizeNode(locale, <div className={`store-links${compact ? ' compact' : ''}`}>
    <div className="store-row">{product.appStore && <a className="store-link" href={product.appStore}>App Store <ArrowUpRight size={16} aria-hidden="true" /></a>}{product.playStore && <a className="store-link" href={product.playStore}>Google Play <ArrowUpRight size={16} aria-hidden="true" /></a>}</div>
    {(!product.appStore || !product.playStore) && <p className="availability">{!product.appStore && !product.playStore ? 'iOS & Android · Coming soon' : !product.playStore ? 'Android · Coming soon' : 'iOS · Coming soon'}</p>}
    {!compact && product.availabilityNote && <p className="availability">{product.availabilityNote}</p>}
  </div>)
}
